export const config = {
   NASA_API_KEY: process.env.REACT_APP_NASA_API_KEY
}
